import { render } from "./DeptHeader.vue?vue&type=template&id=357b5e01"
import script from "./DeptHeader.vue?vue&type=script&lang=js"
export * from "./DeptHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__